import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, Injector } from '@angular/core';

import { Observable, filter, forkJoin, map, of } from 'rxjs';

import { environment } from 'src/environments/environment';

import Swal from 'sweetalert2';

import * as CryptoJS from 'crypto-js';

import { NavigationEnd, Router } from '@angular/router';

import { OtherService } from 'src/app/services/other.service';

@Injectable({

  providedIn: 'root',

})

export class AccountService {

  encryptionKey = environment.encryptionKey;

  list_StoredAds: any = [];

  list_StoredCity: any = [];

  list_StoredCity_By_Image: any = [];

  list_StoredNews: any = [];

  list_StoredCategory: any = [];

  list_StoredCurrency: string = '';

  list_StoredCondition: any = [];

  list_Stored_CityList4Support: any = [];

  list_Stored_groups: any = [];

  list_Stored_groupsSamsari: any = [];

  list_Stored_groupsEmploy: any = [];

  tiType_Stored: number;

  bDateJalali_Stored: boolean | null = null;

  private currentUrl: string = '';

  constructor(private http: HttpClient, private injector: Injector) {

    const router = this.injector.get(Router);

    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {

      this.currentUrl = event.url;

      this.tracker_Visits();

      this.getBasic_Info();

    });

  }

  async tracker_Visits() {

    if (!window.origin.includes('localhost')) {

      const UserAgent = navigator.userAgent;

      let strDevice: string = 'Unknown Device';

      if (/iPad/.test(UserAgent)) {
        strDevice = 'iPad';
      }

      else if (/iPhone/.test(UserAgent)) {
        strDevice = 'iPhone';
      }

      else if (/Android/.test(UserAgent)) {
        strDevice = 'Android';
      }

      else if (/Windows/.test(UserAgent)) {
        strDevice = 'Windows';
      }

      const getOS = (): string => {
        // Using a simplified method to get the OS name
        if (/Windows NT/.test(UserAgent)) return 'Windows';
        if (/Macintosh/.test(UserAgent)) return 'Mac OS';
        if (/Android/.test(UserAgent)) return 'Android';
        if (/iOS/.test(UserAgent)) return 'iOS';
        return 'Unknown OS';
      };

      const strOS = getOS();

      const model = {
        iTaxiLon_User: this.getLocalStorage().Id || 0,   // User id
        strNavigator: navigator.userAgent,   // Browser name and version
        strLanguage: navigator.language,     // Language
        strDevice: strDevice,                // Device name
        strOS: strOS,                        // Operating System
        strEffectiveType: 'unknown', // Network type
        strURL: window.origin + this.currentUrl, // Full page URL
        strReferrer: document.referrer,      // Referring page URL
      };

      try {

        const response = await fetch(environment.taxiUrl + `TrackPageVisit`, {

          method: 'POST',

          headers: { 'Content-Type': 'application/json' },

          body: JSON.stringify(model),

        });

        // console.log('Server Response:', await response.json());

      }

      catch (error) {

        console.error('Error:', error);

      }

    }

  }

  async getBasic_Info() {

    // if (true) {

    if (!localStorage.getItem('XDid7TYzRFD')) {

      try {

        const response = await fetch(environment.taxiUrl + `Taxilon_BaseInfo?tiAppType=1`, {

          method: 'POST',

          headers: { 'Content-Type': 'application/json' },

        });

        let res = await response.json();

        localStorage.setItem('XDid7TYzRFD', this.encrypt(JSON.stringify(res)));

        const OtherService_ = this.injector.get(OtherService);

        OtherService_.changeUserInfo_Status(true);

      }

      catch (error) {

        console.error('Error:', error);

      }


    }

  }

  getLocalStorage() {

    if (localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')) {

      var item = JSON.parse(this.decrypt(localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')!))

      return item;

    }

    else return {}

  }


  toastSwal(type, string, timer?) {
    if (timer === undefined) {
      timer = 3000;
    }
    Swal.fire({
      position: 'bottom-end',
      icon: type,
      toast: true,
      background:
        type == 'success'
          ? '#008631'
          : type == 'error'
            ? '#DF1C24'
            : type == 'warning'
              ? '#54c3e6'
              : '#3fc3ee',
      color: '#fff',
      timerProgressBar: true,
      title: string,
      customClass: {
        title: 'toaster-lineSpacing',
      },
      showConfirmButton: false,
      timer: timer,
    });
  }

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.encryptionKey).toString();
  }

  decrypt(value: string) {
    return value != null
      ? CryptoJS.AES.decrypt(value, this.encryptionKey).toString(
        CryptoJS.enc.Utf8
      )
      : '';
  }

  //  taxilon api from here//////////////////////////////////////////

  taxiLogin(model: any) {
    return this.http.post(environment.taxiUrl + 'TaxiLon_User_CheckUser', model);
  }

  taxiCheckOTP(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_CheckOTP`, model);
  }

  taxiSubmit(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_InitialRegistration`, model);
  }
  TaxiLon_City_List() {
    return this.http.post(environment.taxiUrl + `TaxiLon_City_List`, {});
  }
  TaxiLon_MobileGroup_List() {
    return this.http.post(environment.taxiUrl + `TaxiLon_MobileGroup_List`, {});
  }
  TaxiLon_User_TravelCostEstimate(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_TravelCostEstimate`, model);
  }
  TaxiLon_Trip_Passenger_Save(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_Save`, model);
  }
  taxiLon_PayInvoice(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_ReturnIntermediateLink`, { ...model, tiAppType: 1 });
  }
  TaxiLon_News(model) {
    return this.http.post(environment.taxiUrl + `TaxilLon_News_List?iPage=${model.iPage}`, {});
  }
  TaxiLon_AtLeastTime() {
    return this.http.post(environment.taxiUrl + `TaxiLon_AtLeastTime`, {});
  }
  TaxiLon_News_Info(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_News_Info?iNews=${model}`, {});
  }
  TaxiLon_Trip_Passenger_List(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_List`, model);
  }
  TaxiLon_Trip_Passenger_Cancel(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_Cancel`, model);
  }
  TaxiLon_Trip_Passenger_SetPoints(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_SetPoints`, model);
  }
  TaxiLon_Tiket_List(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_List`, model);
  }
  TaxiLon_Tiket_Subjects_List(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Subjects_List`, model);
  }
  TaxiLon_Tiket_Save(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Save`, model);
  }
  TaxiLon_Tiket_Delete(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Tiket_Delete`, model);
  }
  TaxiLon_User_Update(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_Update`, model);
  }
  TaxiLon_EvidenceDriver_List4Passenger(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_EvidenceDriver_List4Passenger`, model);
  }
  Captcha_Get() {
    return this.http.post(environment.taxiUrl + `Captcha_Get`, {});
  }
  getTaxiLon_Drivers() {
    return this.http.post(environment.taxiUrl + `TaxiLon_Drivers`, {});
  }
  TaxiLon_EvidenceDriver_Info4Passenger(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_EvidenceDriver_Info4Passenger`, model);
  }
  taxiLon_CheckPoints(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_User_CheckTripHasNoPoints`, model);
  }
  taxiLon_SetPoints(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_SetPoints`, model);
  }

  TaxiLon_Opinions() {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_PassengerOpinions`, {});
  }
  partner_Register(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_Register`, model);
  }
  partner_Login(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_Login`, model);
  }
  partner_OTP(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_CheckOTP`, model);
  }
  partner_Reset_Password(strMobile) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Partner_ForgetPassword?strMobile=${strMobile}`, {});
  }
  checkPayment(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Passenger_CheckPayment`, model);
  }

  TaxiLon_City_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_City_4PublicSearch`, model);
  }

  TaxiLon_MobileType_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_MobileType_4PublicSearch`, model);
  }

  TaxiLon_GPSType_Search(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_GPSType_4PublicSearch`, model);
  }

  Taxilon_Advertisement(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_List`, model);
  }

  Taxilon_Ads_Info(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_Info`, model);
  }

  TaxiLon_Ads_Gallery(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Gallery_List?iTaxilon_Advertisement=${model.iTaxilon_Advertisement}`, {});
  }

  Taxilon_DynamicLink(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_DynamicLink?strSiteUrl=${model.strSiteUrl}&iTaxilon_Advertisement=${model.iTaxilon_Advertisement}`, {});
  }

  get_AdsDetail_VS_Gallery(model): Observable<any> {

    return forkJoin([

      this.Taxilon_Ads_Info(model),

      this.TaxiLon_Ads_Gallery(model),

      this.Taxilon_DynamicLink(model)

    ]).pipe(map(([adsInfo, gallery, links]) => ({ adsInfo, gallery, links })));

    // ]).pipe(map(([adsInfo, gallery]) => ({ adsInfo, gallery })));

  }

  Taxilon_Ads_New() {
    return this.http.post(environment.taxiUrl + `Taxilon_Advertisement_Public_List_New`, {});
  }

  Taxilon_Ads_Number(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_GetUserInfo`, model);
  }

  Taxilon_Ads_Note(model) {

    fetch(environment.taxiUrl + `Taxilon_Advertisement_RecentVisit_UpdateComment`, {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify(model),

    });

  }

  Taxilon_GetHelp() {
    return this.http.post(environment.taxiUrl + `Taxilon_GetHelp?ID=200`, {});
  }

  TaxiLon_MobileGroup() {
    return this.http.post(environment.taxiUrl + `TaxiLon_MobileGroup_List`, {});
  }

  Taxilon_AdsType(model) {
    return this.http.post(environment.taxiUrl + `Taxilon_AdvertisementType_List`, model);
  }

  Educational_List() {
    return this.http.post(environment.taxiUrl + `EducationalContent_List`, {});
  }

  Educational_Info(iEducationalContent) {
    return this.http.post(environment.taxiUrl + `EducationalContent_Info?iEducationalContent=${iEducationalContent}`, {});
  }

  taxilon_Route(model) {
    return this.http.post(environment.taxiUrl + `TaxiLon_Trip_Passenger_Route`, model);
  }

}
